module.exports = __webpack_public_path__ + "media/sfx_return-logoutandhome.1bf5d12f.mp3";